export class Constant {
  public static readonly HTTP_TIMEZONE_HEADER: string = 'X-Timezone';

  public static readonly HTTP_UTC_OFFSET_HEADER: string = 'X-UTC-Offset';

  public static readonly HTTP_APP_LANGUAGE_HEADER: string = 'Accept-Language';

  public static readonly HTTP_CUSTOM_HANDLE_ERROR_CODES: string =
    'X-Custom-Handle-Error-Codes';

  public static readonly HTTP_SILENT_MODE: string = 'X-Silent-Mode';

  public static readonly HTTP_IF_MATCH: string = 'If-Match';

  public static readonly HTTP_IGNORE_ERROR: string = 'X-Ignore-Error';

  public static readonly HTTP_APP_VERSION_HEADER: string = 'X-AppVersion';

  // Patterns
  public static readonly PHONE_NUMBER_PATTERN: RegExp =
    /^\+?[0-9\s\-().]{7,20}$/;
  public static readonly EMAIL_PATTERN: RegExp =
    /^[a-zA-Z0-9](\.?[a-zA-Z0-9_%+-])*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,6}$/;

  public static readonly PERSONAL_NAME: RegExp = /^[a-zA-ZÀ-ž\s-]*$/;

  // Supported country codes for postal code validation
  public static readonly SUPPORTED_COUNTRY_CODES: readonly string[] = [
    'US',
    'CA',
    'GB',
    'DE',
    'FR',
    'IT',
    'ES',
    'NL',
    'BE',
    'AT',
    'CH',
    'SE',
    'NO',
    'DK',
    'FI',
    'PL',
    'CZ',
    'SK',
    'HU',
    'RO',
    'BG',
    'HR',
    'SI',
    'EE',
    'LV',
    'LT',
    'MT',
    'CY',
    'LU',
    'IE',
    'PT',
    'GR',
    'AU',
    'NZ',
    'JP',
    'KR',
    'CN',
    'IN',
    'BR',
    'MX',
    'AR',
    'CL',
    'CO',
    'PE',
    'VE',
    'EC',
    'BO',
    'PY',
    'UY',
    'GY',
    'SR',
    'GF',
    'FK',
    'GS',
    'IO',
    'PN',
    'SH',
    'TC',
    'VG',
    'VI',
    'AI',
    'BM',
    'IO',
    'KY',
    'MS',
    'PR',
    'AS',
    'GU',
    'MP',
    'PW',
    'FM',
    'MH',
    'NR',
    'CK',
    'NU',
    'TK',
    'TO',
    'TV',
    'WS',
    'KI',
    'NC',
    'PF',
    'PG',
    'SB',
    'VU',
    'FJ',
    'NF',
    'AQ',
    'BV',
    'TF',
    'HM',
    'CC',
    'CX',
  ] as const;
}
